




























































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { actionsEvent } from '@/setup';
import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import { fetchMS } from './fetchMS';
//import modalCREARDetalleAltaServicio from '@/pantallas/Conecta/AltasServicio/modal_crear_detalle_alta.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import config from '@/config/index';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { Console } from 'console';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    MantenedorGrid,
    DatePicker,
    MantenedorGridSinCodigo,
    appconfirmacion: Confirmation,
  },
})
export default class modalVerDetalleCuadratura extends Vue {
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.conecta_cuadraturas_detalle;
  @Prop({ default: null }) ID_CUADRATURA: any;
  @Prop({ default: true }) show: boolean;
  GRILA_DETALLE_CUADRATURA: any;
  @Prop({ default: null }) ID_SOLICITUD: any;
  showReporteGenerado: boolean = false;
  texto_reporte: string = 'TEXTO CUERPO MODAL';
  LISTA_FOTOS: any[] = [];
  showEvidenciasDialog: boolean = false;
  mostrarModalCONFIRMARdet: boolean = false;
  Modal_confirmar_TEXTOdet: any = '';
  gridApi: GridApi = null;

  constructor() {
    super();
    actionsEvent.onVerEvidenciasFila(this.handlerbuttonmodalEvidenciasFila);
    actionsEvent.onFinalizar(this.handlerbuttonmodalFinalizardet);
  }

  accionverEvidenciasFila: PermisoAccion = {
    accionCodigo: 133,
    visible: false,
  };
  accionFinalizar: PermisoAccion = {
    accionCodigo: 128,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [
    this.accionverEvidenciasFila,
    this.accionFinalizar,
  ];

  handlerbuttonmodalEvidenciasFila(params: ICellRendererParams) {
    this.LISTA_FOTOS = null;
    this.showEvidenciasDialog = false;
    console.log(
      params.data['Nro Solicitud'] +
        ' ' +
        params.data['Número Cuadratura'] +
        ' ' +
        params.data['Serie Nueva']
    );
    this.loadingService.showLoading(undefined, 'det_evidencias_fila');
    return fetchMS(
      {
        id_cuadratura: params.data['Número Cuadratura'],
        id_solicitud: params.data['Nro Solicitud'],
        serie: params.data['Serie Nueva'],
      },
      'get_evidencias_fila'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.loadingService.hideLoading('det_evidencias_fila');
          this.LISTA_FOTOS = data.data.data;
          this.showEvidenciasDialog = true;
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('det_evidencias_fila');
      })
      .finally(() => {
        this.loadingService.hideLoading('det_evidencias_fila');
      });
  }

  handlerbuttonmodalFinalizardet(params: ICellRendererParams) {
    this.ID_CUADRATURA = params.data['Número Cuadratura'];
    this.ID_SOLICITUD = params.data['Nro Solicitud'];
    this.Modal_confirmar_TEXTOdet =
      '¿Está seguro que desea devolver Finalizar orden ' +
      this.ID_SOLICITUD +
      ' ?';
    this.mostrarModalCONFIRMARdet = true;
  }

  async confirmCallbackdet(val: boolean) {
    const self = this;
    if (val == true) {
      self.mostrarModalCONFIRMARdet = false;
      self.loadingService.showLoading(undefined, 'finalizar_solicitud');
      return fetchMS(
        {
          id_cliente: this.getCliente(),
          id_usuario: this.getUserID(),
          modulo_id: 265,
          id_cuadratura: this.ID_CUADRATURA,
          id_solicitud: this.ID_SOLICITUD,
        },
        'finalizar_solicitud'
      )
        .then((data: any) => {
          self.loadingService.hideLoading('finalizar_solicitud');
          self.mostrarModalCONFIRMARdet = false;
          if (Number(data.data.CODIGO_RESPUESTA) > 1) {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA);
            self.mostrarModalCONFIRMARdet = false;
          } else {
            self.$snotify.success(data.data.MENSAJE_RESPUESTA);
            self.mostrarModalCONFIRMARdet = false;
          }
        })
        .catch((error: any) => {
          self.loadingService.hideLoading('finalizar_solicitud');
          self.mostrarModalCONFIRMARdet = false;
          return null;
        })
        .finally(() => {
          self.loadingService.hideLoading('finalizar_solicitud');
          self.mostrarModalCONFIRMARdet = false;
          return null;
        });
    } else {
      self.mostrarModalCONFIRMARdet = false;
    }
  }

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Número Cuadratura',
        field: 'Número Cuadratura',
        hide: true,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nro Solicitud',
        field: 'Nro Solicitud',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Solicitud',
        field: 'Fecha Solicitud',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Patente Original',
        field: 'Patente Original',
        hide: false,
        width: 170,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Patente Nueva',
        field: 'Patente Nueva',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Operaci\u00f3n',
        field: 'Operaci\u00f3n',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Producto Original',
        field: 'Producto Original',
        hide: false,
        width: 170,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Producto Nuevo',
        field: 'Producto Nuevo',
        hide: false,
        width: 170,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Serie Original',
        field: 'Serie Original',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Serie Nueva',
        field: 'Serie Nueva',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Modelo Original',
        field: 'Modelo Original',
        hide: false,
        width: 170,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Modelo Nuevo',
        field: 'Modelo Nuevo',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Año Original',
        field: 'Año Original',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Año Nuevo',
        field: 'Año Nuevo',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Marca Original',
        field: 'Marca Original',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Marca Nueva',
        field: 'Marca Nueva',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'EPC',
        field: 'EPC',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'SIM Original',
        field: 'SIM Original',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'SIM Nueva',
        field: 'SIM Nueva',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Telco Original',
        field: 'Telco Original',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Telco Nueva',
        field: 'Telco Nueva',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Código Interno Vehículo',
        field: 'Codigo Interno Vehículo',
        hide: false,
        width: 200,
        cellStyle: { textAlign: 'left' },
      },
      /* {
        headerName: 'Validado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        cellRenderer: this.getHtml_validado,
        show: false,
      },
      {
        headerName: 'Existencia',
        field: 'Existencia',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        cellRenderer: this.getHtml_Existencia,
        show: false,
      }, */

      {
        headerName: 'T\u00e9cnico',
        field: 'T\u00e9cnico',
        hide: false,
        width: 170,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado',
        field: 'Finalizado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 180,
      },
      {
        headerName: 'Glosa CRM',
        field: 'Glosa CRM',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
    ].map(x => ({
      width: 300,
      hide: false,
      ...x,
    })),
    pagination: true,
    paginationPageSize: 30,
    onGridReady: this.handleGridReady,
  };

  async btn_ver_evidencias() {
    this.showEvidenciasDialog = true;
    this.LISTA_FOTOS = null;
    await this.det_detalle_cuadratura();
  }

  async handleGridReady(event: GridReadyEvent) {
    let lista = await this.det_detalle_cuadratura();
    this.gridApi = event.api;
    this.gridApi.setRowData(lista);
    this.gridApi.setDomLayout('autoHeight');
  }

  async handleCierreModal() {
    this.showEvidenciasDialog = false;
    this.LISTA_FOTOS = null;
  }

  async mounted() {
    /*   console.log('onDialogChanged');
    console.log('abro modal ver detalle CUADRATURA', this.ID_CUADRATURA); */
    //let res = await this.det_detalle_cuadratura();
  }

  async det_detalle_cuadratura() {
    this.LISTA_FOTOS = null;
    this.loadingService.showLoading(undefined, 'det_detalle_cuadratura');
    return fetchMS(
      {
        id_cuadratura: this.ID_CUADRATURA,
        id_solicitud: this.ID_SOLICITUD,
      },
      'get_detalle_cuadratura'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('det_detalle_cuadratura');
        this.GRILA_DETALLE_CUADRATURA = data.data.data.LISTA;
        this.LISTA_FOTOS = data.data.EVIDENCIAS;
        return this.GRILA_DETALLE_CUADRATURA;
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('det_detalle_cuadratura');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('det_detalle_cuadratura');
        return null;
      });
  }

  getHtml_Existencia(params: any): string {
    if (params.data.Existencia == 'f') {
      return '<i class="material-icons"  title="false" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;" ></i>';
    } else {
      return '<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: #26FF26; border-radius: 50%;" ></i>';
    }
  }
  getHtml_validado(params: any): string {
    if (params.data.Validado == 'f') {
      return '<i class="material-icons"  title="false" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;" ></i>';
    } else {
      return '<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: #26FF26; border-radius: 50%;" ></i>';
    }
  }

  getHtml_Finalizado(params: any): string {
    if (params.data.Finalizado == 'f') {
      return '<i class="material-icons"  title="false" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;" ></i>';
    } else {
      return '<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: #26FF26; border-radius: 50%;" ></i>';
    }
  }

  btn_exportar() {
    let body: { [key: string]: string } = {
      id_solicitud: this.ID_SOLICITUD,
    };
    this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchMS(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '266',
      },
      'exportar_csv_solicitud'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('btn_exportar');
        return data.data;
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('btn_exportar');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('btn_exportar');
        return null;
      });
  } //end btn_exportar

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }
  showInfo: boolean = true;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  closeModal() {
    this.$emit('modalverDetalleEmit', false);
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;

    return id;
  }
}
